import { render, staticRenderFns } from "./FormTableConfigDialog.vue?vue&type=template&id=7c105f20&"
import script from "./FormTableConfigDialog.vue?vue&type=script&lang=js&"
export * from "./FormTableConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports